import DriverAppReleasesApi from "../../services/api/DriverAppReleases";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import { getPath } from "../../utils";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in driver app releases actions:", err);
}

export const setAppReleasesList = (payload) => {
  return {
    type: ActionTypes.SET_APP_RELEASES_LIST,
    payload,
  };
};

export const setActiveAppRelease = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_APP_RELEASE,
    payload,
  };
};

export const setActiveFiltersAppReleases = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_APP_RELEASES_FILTERS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_DRIVER_APP_RELEASES,
    payload,
  };
};

export const setCurrentPageAppReleases = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_APP_RELEASES,
    payload,
  };
};

export const getAppReleasesList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        filters: { ...filters },
        page_request: { ...pageRequest },
      };
      dispatch(setLoader(true));
      let response = await DriverAppReleasesApi.getAppReleasesList(
        finalPayload
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setAppReleasesList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageAppReleases(getPath(pageRequest, "page", 1)));
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFiltersAppReleases(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
        return response;
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getActiveAppRelease = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverAppReleasesApi.getActiveAppRelease(id);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActiveAppRelease(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createAppRelease = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverAppReleasesApi.createAppRelease(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.CREATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateAppRelease = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await DriverAppReleasesApi.updateAppRelease(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const launchAppRelease = (id, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverAppReleasesApi.launchAppRelease(id, payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.RELEASE_LAUNCH,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const bulkUploadDriverIds = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverAppReleasesApi.bulkUploadDriverIds(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const downloadAppApks = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverAppReleasesApi.downloadAppApks(id);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const uploadAppApks = (filename) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const payload = {
      filename: filename,
    };
    let response = await DriverAppReleasesApi.uploadAppApks(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
